import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';
import {
    Inject,
    Injectable
} from '@angular/core';
import {
    BehaviorSubject,
    catchError,
    interval,
    map,
    Observable,
    of,
    startWith,
    switchMap,
    take,
    takeWhile,
    tap, filter,
    forkJoin,
    concatMap,
    combineLatest,
    Subject,
    EMPTY,
    takeUntil
} from 'rxjs';
import { BACKEND_URLS, BackendUrls } from 'app/app.config';
import { Istanza, IstanzeService } from './istanze.service';
import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';


export interface TipoImporto {
    id: string;
    descrizione?: string;
}


export interface ChiaveDebito{
    idpos: string;
    iddeb: string;
    codice: string;
}

export interface Importo {
    id?: string;
    pagamento_id?: string;
    tipo: string;
    prog?: number;
    importo: number;
    causale?: string;
    tipo_importo?: TipoImporto;
}

export interface Pagamento {
    id?:string;
    enabled?:boolean;
    document_id?: string;
    app_name?: string;
    idpos?:string;
    iddeb?:string;
    iuv?:string;
    descrizione?:string;
    modello?:string;
    tipo?:string;
    red_url?:string;
    servizio?:string;
    importo?: number;
    causale?:string;
    data_inizio?:string;
    data_scadenza?:string;
    data_scadenza_avviso?:string;
    tipo_scadenza?:string;
    data_pagamento?:string;
    data_inserimento?:string;
    stato?:string;
    esito?:string;
    accertamento?:string;
    gruppo?:string;
    ordinamento?: number;
    rata?: number
    tassonomia?:string;
    soggetto?:string;
    cf_piva?:string;
    nome?:string;
    cognome?:string;
    denominazione?:string;
    indirizzo?:string;
    civico?:string;
    cap?:string;
    loc?:string;
    prov?:string;
    nazione?:string;
    email?:string;
    azione?:string;
    importi?: Importo[];

  }


@Injectable({
    providedIn: 'root',
})
export class PagopaService {

    _pagamenti: BehaviorSubject<Pagamento[]> = new BehaviorSubject([]);

    get pagamenti$(): Observable<Pagamento[]> {
        return this._pagamenti.asObservable();
    }

    constructor(
        @Inject(BACKEND_URLS) private backendUrls: BackendUrls,
        private _httpClient: HttpClient,
        private _istanzeService: IstanzeService,
        private route: ActivatedRoute
    ) { }

    getPagamentiAzione(istanza:Istanza, azione: string) {

        return this._httpClient.get<any>(`${this.backendUrls.backendApiUrl}/pagopa/config/${istanza.tipo_id}`, {
                        params: { azione },
                    }).pipe(
                        map(result => result["data"]),
                        switchMap((dovuti) => {
                            const intest = istanza.intestatario;
                            istanza.pagopa = dovuti.length!=0;
                            let causale= '';

                            // Causale specifica in base all'azione
                            if (azione === 'presentazione') {
                                this._pagamenti.next(dovuti);
                                causale = `Presentazione istanza ${istanza.codice}`;
                            } else {
                                const pagamenti = this._pagamenti.value;
                                this._pagamenti.next([...pagamenti,dovuti]);
                                causale = `Pagamento ${azione}`;
                            }

                            dovuti.map(imp => {

                                // Configurazione dei campi del imp
                                imp.document_id = istanza.id;
                                imp.causale = causale;
                                imp.idpos = `${istanza.codice}_${imp.idpos}`;
                                imp.app_name = 'istanze';
                                imp.nome = intest.nome;
                                imp.soggetto = intest.giuridica_opt ? 'G' : 'F';
                                imp.cf_piva = intest.giuridica?.piva ? intest.giuridica.piva : intest.cf;
                                imp.cognome = intest.cognome;
                                imp.denominazione = intest.giuridica?.denominazione;
                                imp.indirizzo = intest.giuridica?intest.giuridica.indirizzo:intest.indirizzo;
                                imp.civico = intest.giuridica?intest.giuridica.civico:intest.civico;
                                imp.cap = intest.giuridica?intest.giuridica.cap:intest.cap;
                                imp.loc = intest.giuridica?intest.giuridica.comune_nome:intest.comune_nome;
                                imp.prov = intest.giuridica?intest.giuridica.comune_prov:intest.comune_prov;
                                imp.email = intest.email;
                                imp.azione = azione;

                            })
                            return dovuti
                        })

                    )


    }


    getPagamentiAzionexx(modulo: string, azione: string, save: boolean = false): Observable<Pagamento> {

        return this.pagamenti$.pipe(
            take(1),
            switchMap((pagamenti) => this._istanzeService.istanza$.pipe(
                switchMap((istanza) =>

                    this._httpClient.get<Pagamento>(`${this.backendUrls.backendApiUrl}/pagopa/config/${modulo}`, {
                        params: { azione },
                    }).pipe(
                        map(result => result["data"]),
                        switchMap((importi) => {
                            debugger
                            const intest = istanza.intestatario;
                            istanza.pagopa = true;
                            let causale= '';

                            // Causale specifica in base all'azione
                            if (azione === 'presentazione') {
                                pagamenti = importi;
                                causale = `Presentazione istanza ${istanza.codice}`;
                            } else {
                                pagamenti = [...pagamenti, importi]
                                causale = `Pagamento ${azione}`;
                            }

                            importi.map(imp => {

                                // Configurazione dei campi del imp
                                imp.document_id = istanza.id;
                                imp.causale = causale;
                                imp.idpos = `${istanza.codice}_${imp.idpos}`;
                                imp.app_name = 'istanze';
                                imp.nome = intest.nome;
                                imp.soggetto = intest.giuridica ? 'G' : 'F';
                                imp.cf_piva = intest.piva ? intest.piva : intest.cf;
                                imp.cognome = intest.cognome;
                                imp.denominazione = intest.denominazione;
                                imp.indirizzo = intest.indirizzo;
                                imp.civico = intest.civico;
                                imp.cap = intest.cap;
                                imp.loc = intest.comune_nome;
                                imp.prov = intest.comune_prov;
                                imp.email = intest.email;
                                imp.azione = azione;

                            })

                            // Aggiungi il pagamento alla lista e aggiorna l'Observable
                            this._pagamenti.next(pagamenti);
                            return pagamenti;
                        })

                    )

                )
            ))
        )

    }

    // Metodo per il polling del pagamento fino a stato "CONLUSO_ESEGUITO"
    private pollPagamentoStato(pagamento: Pagamento): Observable<Pagamento> {
        return interval(10000).pipe( // Esegui ogni minuto
            startWith(0), // Esegui subito il controllo iniziale
            switchMap(() =>
                this._httpClient.get<Pagamento>(`${this.backendUrls.backendApiUrl}/pagopa/stato/${pagamento.id}`)
            ),
            map(result => result["data"]),
            tap(console.log),
            takeWhile((updatedPagamento) => updatedPagamento.esito !== 'CONLUSO_ESEGUITO', true), // Continua finché lo stato non diventa 'CONLUSO_ESEGUITO'
            map((updatedPagamento) => {
                // Aggiorna la lista dei pagamenti
                this.pagamenti$.pipe(take(1)).subscribe((pagamenti) => {

                    console.log(pagamenti)

                    const index = pagamenti.findIndex((p) => p.id === updatedPagamento.id);
                    if (index !== -1) {
                        pagamenti[index] = updatedPagamento;
                        this._pagamenti.next(pagamenti);
                    }

                });
                return updatedPagamento;
            })
        );
    }


    getPagamenti(istanza_id: string, params:any={}): Observable<Pagamento[]> {
        return this._httpClient
            .get<Pagamento[]>(`${this.backendUrls.backendApiUrl}/pagopa/documento/${istanza_id}`, {params:params?.params})
            .pipe(
                map((result) => result['data']),
                tap((pagamenti)=>{
                    this._pagamenti.next(pagamenti)
                }),
                catchError((err: Response) => {
                    if (err.status === 200) {
                        console.log(err['message']);
                    }
                    console.log(err['message']);
                    return of(null);
                })
            );
    }


    delPagamento(pagamento_id: string):Observable<boolean>{

        return this._httpClient
            .delete<boolean>(`${this.backendUrls.backendApiUrl}/pagopa/${pagamento_id}`)
            .pipe(
                catchError((err: Response) => {
                    if (err.status === 200) {
                        console.log(err['message']);
                    }
                    console.log(err['message']);
                    return of(null);
                })
            );

    }

    setPagamento(pagamento_id: string):Observable<Pagamento>{

        return this._httpClient
            .patch<Pagamento>(`${this.backendUrls.backendApiUrl}/pagopa/${pagamento_id}`, {})
            .pipe(
                catchError((err: Response) => {
                    if (err.status === 200) {
                        console.log(err['message']);
                    }
                    console.log(err['message']);
                    return of(null);
                })
            );

    }

    savePagamento(pagamento: Pagamento):Observable<Pagamento>{
        return this._httpClient
            .post<Pagamento>(`${this.backendUrls.backendApiUrl}/pagopa/${pagamento.id}`, pagamento)
            .pipe(
                catchError((err: Response) => {
                    if (err.status === 200) {
                        console.log(err['message']);
                    }
                    console.log(err['message']);
                    return of(null);
                })
            );
    }

    delPagamentiIstanza(istanza: Istanza) {
        if (istanza.stato_id == 'compilazione' || istanza.stato_id == 'riepilogo'){
            return this._httpClient
                .delete<boolean>(`${this.backendUrls.backendApiUrl}/pagopa/documento/${istanza.id}`)
                .pipe(
                    tap(()=>this._pagamenti.next([])),
                    catchError((err: Response) => {
                        if (err.status === 200) {
                            console.log(err['message']);
                        }
                        console.log(err['message']);
                        return of(false);
                    })
                )

        }
    }





    setPagamentoxxxxxxxxxxxx(istanza:Istanza,  pagamento:Pagamento):Observable<Pagamento[] | boolean> {

        if (!pagamento || pagamento.importi.length==0){
            return of(false)
        }

        const intest = istanza.intestatario;
        istanza.pagopa = true;
        pagamento.document_id = istanza.id;
        pagamento.idpos = istanza.codice;
        pagamento.app_name = 'istanze';
        pagamento.nome = intest.nome;
        pagamento.soggetto = intest.giuridica?'G':'F';
        pagamento.cf_piva = intest.piva?intest.piva:intest.cf;
        pagamento.nome = intest.nome;
        pagamento.cognome = intest.cognome;
        pagamento.denominazione = intest.denominazione;
        pagamento.indirizzo = intest.indirizzo;
        pagamento.civico = intest.civico;
        pagamento.cap = intest.cap;
        pagamento.loc = intest.comune_nome;
        pagamento.prov = intest.comune_prov;
        pagamento.email = intest.email;

        pagamento.azione = 'presentazione'

        return this.pagamenti$.pipe(
            take(1),
            switchMap((pagamenti)=>this._httpClient.post<Pagamento>(`${this.backendUrls.backendApiUrl}/pagopa`,pagamento)),
            map(result=>result["data"]),
            tap(result=> {
                const pagamenti= this._pagamenti.value;
                pagamenti.push(result);
                this._pagamenti.next(pagamenti)
            })
        )

    }

    pagamentoOnline(pagamento_id: string): Observable<any> {
        return this._httpClient.post<any>(`${this.backendUrls.backendApiUrl}/pagopa/${pagamento_id}/online`, { red_url: window.location.href }).pipe(
            map(result => result["data"]),
            catchError((err: Response) => {
                if (err.status === 200) {
                    console.log(err['message']);
                }
                console.log(err['message']);
                return of(false);
            })

        )
    }


    pagamentoAvviso(pagamento_id:string): Observable<Pagamento> {
        return this.pagamenti$.pipe(
            take(1),
            switchMap((pagamenti)=>this._httpClient.post<any>(`${this.backendUrls.backendApiUrl}/pagopa/${pagamento_id}/avviso`,{}).pipe(
                map(result=> {
                    if (result["data"]!=undefined){
                        const pagamento = result["data"];
                        const index = pagamenti.findIndex(item => item.id === pagamento_id);
                        pagamenti[index].iuv = pagamento.iuv;
                        pagamenti[index].stato = 'AVVISO';
                        pagamenti[index].data_scadenza = pagamento.data_scadenza;
                        pagamenti[index].data_scadenza_avviso = pagamento.data_scadenza_avviso;
                        this._pagamenti.next(pagamenti)
                        return pagamento
                    }
                    return result
                }),
                catchError((err: Response) => {
                    if (err.status === 200) {
                        console.log(err['message']);
                    }
                    console.log(err['message']);
                    return of(false);
                })
            )),


        )




    }


    getInfoPagamento(pagamento_id: string): Observable<any>{
        return this._httpClient.get<any>(`${this.backendUrls.backendApiUrl}/pagopa/${pagamento_id}`).pipe(
            map(result=>result["data"])
        )
    }

    getAvvisoPagamento(pagamento_id: string): Observable<any>{
        return this._httpClient.get(`${this.backendUrls.backendApiUrl}/pagopa/${pagamento_id}/avviso`, { responseType: 'blob' })
    }

    annullaAvvisoPagamento(pagamento_id: string): Observable<any>{
        return this.pagamenti$.pipe(
            take(1),
            switchMap((pagamenti)=>this._httpClient.delete<any>(`${this.backendUrls.backendApiUrl}/pagopa/${pagamento_id}/avviso`,{}).pipe(
                map(result=> {
                    if (result["data"]!=undefined){
                        const pagamento = result["data"];
                        const index = pagamenti.findIndex(item => item.id === pagamento_id);
                        pagamenti[index].iuv = null;
                        pagamenti[index].stato = null;
                        pagamenti[index].data_scadenza = null;
                        pagamenti[index].data_scadenza_avviso = null;
                        this._pagamenti.next(pagamenti)
                        return pagamento
                    }
                    return result
                }),
                catchError((err: Response) => {
                    if (err.status === 200) {
                        console.log(err['message']);
                    }
                    console.log(err['message']);
                    return of(false);
                })
            ))
        )
    }


    setInfoPagamento(pagamento: Pagamento):Observable<Pagamento> {
        const deb:ChiaveDebito = {iddeb: pagamento.iddeb, idpos: pagamento.idpos, codice: pagamento.tipo}

        return this.pagamenti$.pipe(
            take(1),
            switchMap(()=>this._httpClient.patch(`${this.backendUrls.backendApiUrl}/pagopa/${pagamento.id}/setinfo`, deb, {params:this.route.snapshot.queryParams})),
            map(result=>result["data"]),
            tap(result=> {
                const pagamenti = this._pagamenti.value;
                const index = pagamenti.findIndex(item => item.id === result.id);
                pagamenti[index] = result;
                this._pagamenti.next(pagamenti);
            })
        )
    }






    verificaPagamenti = (azione: string): Observable<boolean> => {
        return this.pagamenti$.pipe(
          take(1), // Prende un valore dal BehaviorSubject corrente
          switchMap((pagamenti) => {
            // Filtra i pagamenti con stato INSERITO
            const pagamentiDaVerificare = pagamenti.filter(
              (pagamento) => pagamento.azione === azione && (pagamento.stato === "INSERITO" || pagamento.stato === null)
            );

            if (pagamentiDaVerificare.length === 0) {
              // Nessun pagamento da verificare, restituisce immediatamente true
              return of(true);
            }

            // Effettua chiamate HTTP per aggiornare i pagamenti
            return forkJoin(
              pagamentiDaVerificare.map((pagamento) =>
                this._httpClient
                  .get<Pagamento>(`${this.backendUrls.backendApiUrl}/pagopa/${pagamento.id}/stato`)
                  .pipe(
                    map((result) => ({
                      ...pagamento, // Mantiene i dati originali del pagamento
                      ...result["data"], // Aggiorna con i dati ricevuti
                    })),
                    catchError((err) => {
                      console.error(`Errore nella verifica del pagamento ${pagamento.id}:`, err.message);
                      return of({ ...pagamento, esito: "ERRORE" }); // Considera errore locale
                    })
                  )
              )
            ).pipe(
              map((pagamentiAggiornati) => {
                // Aggiorna il BehaviorSubject con i nuovi pagamenti
                const nuoviPagamenti = pagamenti.map((pagamento) =>
                  pagamentiAggiornati.find((aggiornato) => aggiornato.id === pagamento.id) || pagamento
                );

                this._pagamenti.next(nuoviPagamenti); // Aggiorna il BehaviorSubject

                // Restituisce true se tutti i pagamenti sono completati
                return nuoviPagamenti.every((p) => p.esito === "CONCLUSO_ESEGUITO");
              })
            );
          })
        );
    };

    checkPagamenti(azione: string) {
        const stopInterval$ = new Subject<void>(); // Soggetto per controllare l'interruzione

        // Avvia il polling solo se ci sono pagamenti con stato INSERITO
        this.pagamenti$.pipe(
            take(1),
            map((pagamenti) =>
                pagamenti.some((pagamento) => pagamento.stato === "INSERITO")
            ),
            switchMap((shouldStartPolling) => {
                if (!shouldStartPolling) {
                    console.log("Nessun pagamento con stato 'INSERITO', polling non avviato");
                    return EMPTY; // Non avvia il polling
                }

                // Avvia il polling ogni 10 secondi
                //verifico se c'è un pagamento fatto con azione presentazione che era in attesa
                console.log("Avvio il polling per verificare il pagamento")

                return interval(10000).pipe(
                    startWith(0), // Esegui subito il controllo iniziale
                    switchMap(() => this.verificaPagamenti(azione)),
                    switchMap((tuttiPagamentiCompletati) =>
                        tuttiPagamentiCompletati
                            ? this._istanzeService.inoltraIstanza().pipe(
                                tap(() => {
                                    stopInterval$.next(); // Ferma il polling
                                    //this.updateFormFields(); // Aggiorna i campi del form
                                })
                            )
                            : of(null) // Nessuna azione se i pagamenti non sono completati
                    ),
                    takeUntil(stopInterval$) // Interrompe l'osservabile quando `stopInterval$` emette
                );
            })
        ).subscribe({
            next: () => console.log("Verifica pagamento......"),
            error: (err) => console.error("Errore durante il polling:", err),
            complete: () => console.log("Verifica pagamenti in attesa completata"),
        });
    }





}
